import client from '../../api';
import { specialties, subspecialties } from '../../api/endpoints';

const specialtyEndpoint = specialties.index;
const subSpecialtyEndpoint = subspecialties.index;

export const loadSpecialties = () => client.get(specialtyEndpoint, {}, false);

export const loadSubSpecialties = () => client.get(subSpecialtyEndpoint);
